import React from 'react';
import { number, string } from 'prop-types';
import i18next from 'i18next';
import Typography from '@mui/material/Typography';

import styles from '../../styles.module.scss';

import ChannelWithId from './ChannelWithId';

function Title({ id, channel, displayId }) {
  return (
    <div className={`row middle space-between m-top-2 m-left-2 m-right-2 ${styles.border}`}>
      <Typography fontWeight="fontWeightBold" variant="h6" sx={{ color: 'black' }}>
        {i18next.t('OrdersDetails:details')}
      </Typography>
      {id ? <ChannelWithId channel="mercat">#{id}</ChannelWithId> : null}
      {displayId ? <ChannelWithId channel={channel}>#{displayId}</ChannelWithId> : null}
    </div>
  );
}

Title.propTypes = {
  channel: string,
  displayId: string,
  id: number
};

export default Title;
